import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { pricingRulesApi } from '@/features/pricing-rules/services/pricing-rules-api';
import { ComoEstaCadaProducto } from '@/features/pricing-rules/components/como-esta-cada-producto';
import type { PricingRule } from '@/features/pricing-rules/types/pricing-rules.types';
import { ProductHistoryDialog } from './product-history-dialog';

/**
 * El destino Productos (plan 3 · P3-D2): «Cómo está cada producto» (S10 del
 * plan 4B) sobre la foto del catálogo (4B-datos T8), con el historial de precios
 * de cada producto a un clic. La pregunta que contesta: qué le pasa a cada
 * producto con sus reglas y su estrategia, qué le pasó antes, y por qué.
 *
 * La vista vieja de productos vinculados (`linked-products-view`) queda detrás
 * de la bandera: vive de `DynamicPriceLog STRATEGY_APPLIED`, que el evaluador
 * nuevo no escribe, así que no ve lo que mueven las estrategias de hoy.
 *
 * Agregados del 29-sep (spec 232, A5): «¿Y si…? → Crear esta regla» (P3-D11) se
 * fue con «¿Y si…?»; las reglas se crean en la pestaña Reglas. La lista de
 * reglas sólo alimenta el filtro «por regla»: si no llega, la foto se ve igual.
 */
export function DestinoProductos() {
  const [params] = useSearchParams();
  // La tarjeta «sin costo» de Decisiones llega con `?filtro=sin-costo` (Compite ›
  // Estrategia, donde `?ver=` elige la pestaña). `?ver=sin-costo` es la dirección
  // de antes, en `/precio-inteligente`: sigue valiendo.
  const [filtroInicial] = useState(() =>
    params.get('filtro') === 'sin-costo' || params.get('ver') === 'sin-costo'
      ? { sinCosto: true }
      : null
  );
  const [reglas, setReglas] = useState<PricingRule[]>([]);
  const [historial, setHistorial] = useState<{ productId: string; name: string } | null>(null);
  // Ronda 1 (I2): después de volver desde el historial, la foto se pide de nuevo.
  const [version, setVersion] = useState(0);

  useEffect(() => {
    let vivo = true;
    pricingRulesApi
      .list()
      .then((r) => vivo && setReglas(r))
      .catch(() => vivo && setReglas([]));
    return () => {
      vivo = false;
    };
  }, []);

  return (
    <>
      <ComoEstaCadaProducto
        reglas={reglas}
        filtroInicial={filtroInicial}
        onVerHistorial={setHistorial}
        version={version}
      />
      <ProductHistoryDialog
        open={historial !== null}
        onOpenChange={(v) => !v && setHistorial(null)}
        productId={historial?.productId ?? null}
        productName={historial?.name ?? ''}
        onVolvio={() => setVersion((v) => v + 1)}
      />
    </>
  );
}
